export default __webpack_public_path__ + "static/media/038-beam.ec7ce803.svg";